import { gsap } from 'gsap';
import { useEffect, useRef } from 'react';


const Socials = () => {

    const listRef = useRef(null);

    useEffect(() => {
        const items = Array.from(listRef.current.children);

        // the CSS hover transition on these items fights GSAP's inline styles,
        // so disable it for the entrance and let clearProps hand control back
        items.forEach((el) => { el.style.transition = 'none'; });

        gsap.fromTo(items,
            { opacity: 0, y: 65, rotate: 360 },
            {
                opacity: 1,
                y: 0,
                rotate: 0,
                duration: 1,
                delay: 1,
                ease: "Bounce.easeOut",
                stagger: {
                    amount: 0.3
                },
                clearProps: 'all',
            }
        );

    }, []);

    return (
        <ul ref={listRef}>
            <li className="link-item">
                <a href="https://github.com/LONGYKING" target="_blank" rel="noreferrer" aria-label="GitHub">
                    <i className="fab fa-github"></i>
                </a>
            </li>
            <li className="link-item">
                <a href="https://www.linkedin.com/in/kings-longinus-46a868187/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                    <i className="fab fa-linkedin"></i>
                </a>
            </li>
            <li className="link-item">
                <a href="https://x.com/icodeidea" target="_blank" rel="noreferrer" aria-label="X (Twitter)">
                    <i className="fab fa-x-twitter"></i>
                </a>
            </li>
            <li className="link-item">
                <a href="https://www.faciey.com/therealking" target="_blank" rel="noreferrer" aria-label="Faciey profile">
                    <i className="fas fa-user-circle"></i>
                </a>
            </li>
            <li className="link-item">
                <a href="mailto:kingsleyonyeneke@gmail.com" aria-label="Email">
                    <i className="fas fa-envelope"></i>
                </a>
            </li>
        </ul>
    );
}

export default Socials;
